import axios from 'axios';

const updateSupraLockboxGrantees = async (
  deviceSerialNumber: number,
  lockboxId: string,
  userIds: string[],
  officeWidePermissions?: boolean,
) => {
  await axios.post(`/supra/update_grantees/${lockboxId}`, {
    deviceSerialNumber,
    lockboxId,
    userIds,
    officeWidePermissions,
  });
};

export default updateSupraLockboxGrantees;
